<template>
  <div class="crew-page">
    <v-container grid-list-xl>
      <v-layout row wrap>
        <v-flex xs6>
          <h1>Crews</h1>
        </v-flex>
        <v-flex xs6 class="text-right">
          <v-btn color="accent" depressed dark @click=" openAddDialog">Add Crew</v-btn>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-data-table :headers="headers"
                          :items="crews"
                          :search="search"
                          :custom-filter="filterItems"
                          item-key="id"
                          class="elevation-1">
              <template v-slot:item.crewLead="{item}">
                <span>{{item.crewLead.firstName}} {{item.crewLead.lastName}}</span>
              </template>
              <template v-slot:item.action="{ item }">
                <v-icon color="accent"
                        class="mr-2"
                        @click="editDialogForCrew(item)">mdi-square-edit-outline
                </v-icon>
                <v-icon color="error"
                        @click="deleteDialogForCrew(item)">mdi-trash-can-outline
                </v-icon>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <!-- DELETE DIALOG START -->
    <template>
      <v-row justify="center">
        <v-dialog v-model="deleteConfirmDialog" persistent max-width="290">
          <v-card>
            <v-card-title class="headline pt-1 pr-1">
              Confirm Deletion
              <v-spacer></v-spacer>
              <v-btn icon @click="deleteConfirmDialog = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text class="pb-1" v-if="crewTasks.length > 0">
              Deleting this crew will remove them from all crewTasks, are you sure you want to delete this crew?
              <v-list dense>
                <v-subheader>Tasks: </v-subheader>
                <v-list-item v-for="(task, i) in crewTasks" :key="i">
                  <v-list-item-content style="padding: 2px 0px;">
                    {{task.text}}
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
            <v-card-text class="pb-1" v-else> Are you sure you want to delete this crew?</v-card-text>
            <v-alert v-if="this.error !=null" color="error" dark>
              <v-icon size="20" dark>warning</v-icon>
              {{this.error}}
            </v-alert>
            <v-card-actions>
              <div class="flex-grow-1"></div>
              <v-btn outlined color="error" @click="deleteMethod(crewDelete)">Delete</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <!-- DELETE DIALOG END -->
    <!-- EDIT DIALOG START -->
    <template>
      <v-row justify="center">
        <v-dialog v-model="editDialog" persistent max-width="500">
          <v-card>
            <v-card-title v-bind:style="{ backgroundColor: '#1e345d', color: 'white'}">
              <span class="headline">Edit Crew</span>
              <v-spacer></v-spacer>
              <v-btn color="white" icon @click="editDialog = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-select label="Crew Lead" :items="users" v-model="crewUpdate.crewLeadId">
                    </v-select>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field label="Crew Number/Name" v-model="crewUpdate.name"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
              <v-alert v-if="this.error !=null" color="error" dark>
                <v-icon size="20" dark>warning</v-icon>
                {{this.error}}
              </v-alert>
            </v-card-text>
            <v-card-actions>
              <div class="flex-grow-1"></div>
              <v-btn color="accent" depressed block @click="saveEdit(crewUpdate)">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <!-- EDIT DIALOG END -->
    <!-- ADD DIALOG START -->
    <template>
      <v-row justify="center">
        <v-dialog v-model="addDialog" persistent max-width="500">
          <v-card>
            <v-card-title v-bind:style="{ backgroundColor: '#1e345d', color: 'white'}">
              <span class="headline">Add Crew</span>
              <v-spacer></v-spacer>
              <v-btn color="white" icon @click="addDialog = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-select label="Crew Lead" :items="users" v-model="crewAdd.crewLeadId"></v-select>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field label="Crew Number/Name" v-model="crewAdd.name"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
              <v-alert v-if="this.error !=null" color="error" dark>
                <v-icon size="20" dark>warning</v-icon>
                {{this.error}}
              </v-alert>
            </v-card-text>
            <v-card-actions>
              <div class="flex-grow-1"></div>
              <v-btn color="accent" depressed block @click="saveAdd(crewAdd)">Add</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <!-- ADD DIALOG END -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'CrewPage',
  created () {
    this.loadCrews()
    this.loadAllUsers()
  },
  data () {
    return {
      search: '',
      addDialog: false,
      crewAdd: {
        crewLeadId: null,
        name: null
      },
      deleteConfirmDialog: false,
      errorRemoving: null,
      editDialog: false,
      crewDelete: null,
      crewUpdate: {
        crewLeadId: null,
        regionId: null,
        name: null
      }
    }
  },
  methods: {
    ...mapActions({
      loadAllUsers: 'user/loadAllUsers',
      createCrew: 'crew/createCrew',
      loadCrews: 'crew/loadCrews',
      deleteCrew: 'crew/deleteCrew',
      updateCrew: 'crew/updateCrew',
      tasksForCrew: 'crew/getTasksForCrew',
      clear: 'crew/clear'
    }),
    async deleteDialogForCrew (crew) {
      await this.tasksForCrew(crew.id)
      this.clear()
      this.deleteConfirmDialog = true
      this.crewDelete = crew
    },
    async deleteMethod (crew) {
      await this.deleteCrew(crew)

      if (this.error == null) {
        this.deleteConfirmDialog = false
      } else {
        this.deleteConfirmDialog = true
      }
    },
    editDialogForCrew (crew) {
      this.clear()
      this.editDialog = true
      this.crewUpdate = crew
    },
    async saveEdit (crew) {
      await this.updateCrew(crew)
      if (this.error == null) {
        this.editDialog = false
      } else {
        this.editDialog = true
      }
    },
    openAddDialog () {
      this.crewAdd = {}
      this.clear()
      this.addDialog = true
    },
    async saveAdd (crew) {
      await this.createCrew(crew)
      if (this.error == null) {
        this.addDialog = false
      } else {
        this.addDialog = true
      }
    },
    filterItems (value, search, item) {
      search = search.toString().toLowerCase()
      if (item.crewLead.lastName.toLowerCase().includes(search) ||
                    item.crewLead.firstName.toLowerCase().includes(search) ||
                    item.id.toString().includes(search)) {
        return item
      }
    }
  },
  computed: {
    ...mapGetters({
      users: 'user/selectList',
      crews: 'crew/crews',
      headers: 'crew/headers',
      crewTasks: 'crew/taskListForCrew',
      error: 'crew/error'
    })
  }
}

</script>
<style scoped>
  .search-bar {
    background-color: #ffffff;
    box-shadow: 0 4px 2px -2px #e7e7e9;
  }
</style>
